import CompanyAPI from "@services/company.service"
import {
  CreateCompanyRequest,
  LinkCompanyRequest,
} from "@framework/types/company"
import RootStore from "@store/RootStore"
import { SortBy } from "@framework/types/common"

import CompanyStore from "./company.store"

class CompanyController {
  private companyStore: CompanyStore

  constructor(injections: RootStore) {
    this.companyStore = injections.companyStore
  }

  requestCompaniesReload = () => {
    this.companyStore.triggerReload()
  }

  fetchCompanies = async (options?: SortBy | null) => {
    this.companyStore.loadingCompanies = true
    this.companyStore.error = null
    try {
      const response = await CompanyAPI.getCompanies(
        options != null
          ? {
              sortBy: options.name,
              sortOrder: options.direction ? "ASC" : "DESC",
            }
          : undefined
      )
      this.companyStore.companies = response.data?.map((company, index) => ({
        ...company,
        linkedPublicCompanies: company.linkedPublicCompanies?.filter(
          (item) => !!item
        ),
      }))
    } catch (error: any) {
      this.companyStore.error = error.message
    } finally {
      this.companyStore.loadingCompanies = false
    }
  }

  fetchTrialInstanceCompanies = async () => {
    this.companyStore.loadingCompanies = true
    this.companyStore.error = null
    try {
      const response = await CompanyAPI.getTrialInstanceCompanies()
      this.companyStore.trialInstanceCompanies = response.data
    } catch (error: any) {
      this.companyStore.error = error.message
    } finally {
      this.companyStore.loadingCompanies = false
    }
  }

  createOrUpdateCompany = async (data: CreateCompanyRequest, id?: string) => {
    this.companyStore.loading = true
    this.companyStore.error = null
    try {
      const response = await (id
        ? CompanyAPI.updateCompany(data, id)
        : CompanyAPI.createCompany(data))
      if (response.status === 200) {
        return true
      }
    } catch (error: any) {
      this.companyStore.error = error.message
    } finally {
      this.companyStore.loading = false
    }
    return false
  }

  linkCompanies = async (data: LinkCompanyRequest) => {
    this.companyStore.loading = true
    this.companyStore.error = null
    try {
      const response = await CompanyAPI.linkCompanies(data)
      if (response.status === 200) {
        return true
      }
    } catch (error: any) {
      this.companyStore.error = error.message
    } finally {
      this.companyStore.loading = false
    }
    return false
  }

  startAttributeExtraction = async (companyId: string) => {
    try {
      const response = await CompanyAPI.startAttributeExtraction(companyId)
      if (response.status === 200) {
        return true
      }
    } catch (error: any) {
      return false
    }

    return false
  }

  triggerProductToContentTagging = async (
    companyId: string
  ): Promise<boolean> => {
    try {
      const response = await CompanyAPI.triggerProductToContentTagging(
        companyId
      )
      if (response.status === 200) {
        return true
      }
    } catch (error: any) {
      return false
    }

    return false
  }
}

export default CompanyController
